// Dona Maria Pizzaria - Menu data

export const SIZE_LABELS = {
  broto: "Broto",
  "6f": "6 Fatias",
  "8f": "8 Fatias",
  "12f": "12 Fatias",
};

export const SIZE_ORDER = ["broto", "6f", "8f", "12f"];

const TIER_TRADICIONAL = { broto: 23.0, "6f": 40.9, "8f": 51.9, "12f": 62.9 };
const TIER_ESPECIAL = { broto: 24.0, "6f": 46.9, "8f": 57.9, "12f": 69.9 };
const TIER_PREMIUM = { broto: 26.0, "6f": 50.9, "8f": 61.9, "12f": 72.9 };
const TIER_SUPER = { broto: 28.0, "6f": 56.9, "8f": 67.9, "12f": 77.9 };

const SALGADAS_IMGS = [
  "https://i.imgur.com/jNVemfB.jpeg",
  "https://i.imgur.com/O0ba72I.jpeg",
  "https://i.imgur.com/SaWIP3p.jpeg",
  "https://i.imgur.com/24y1yh1.jpeg",
  "https://i.imgur.com/bQZkWQ8.jpeg",
  "https://i.imgur.com/GshzunQ.jpeg",
  "https://i.imgur.com/13DNYmQ.jpeg",
  "https://i.imgur.com/1HODxAC.jpeg",
];
const DOCES_IMGS = [
  "https://images.unsplash.com/photo-1626082927389-6cd097cdc6ec?auto=format&fit=crop&w=400&q=70",
  "https://images.unsplash.com/photo-1626082929543-5bab6f0dbaea?auto=format&fit=crop&w=400&q=70",
  "https://images.unsplash.com/photo-1571066811602-716837d681de?auto=format&fit=crop&w=400&q=70",
  "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&w=400&q=70",
];
const BEBIDAS_IMGS = [
  "https://images.unsplash.com/photo-1622483767028-3f66f32aef97?auto=format&fit=crop&w=400&q=70",
  "https://images.unsplash.com/photo-1581636625402-29b2a704ef13?auto=format&fit=crop&w=400&q=70",
  "https://images.unsplash.com/photo-1625772299848-391b6a87d7b3?auto=format&fit=crop&w=400&q=70",
];
const withImages = (items, imgs) =>
  items.map((it, i) => ({ ...it, image: imgs[i % imgs.length] }));

const tradicionais = [
  { name: "Calabresa Acebolada", description: "Molho de tomate, mussarela, cebola, calabresa e orégano." },
  { name: "Frango Mussarela", description: "Molho de tomate, frango, cebola, mussarela e orégano." },
  { name: "Dupla Mussarela", description: "Molho de tomate, mussarela dupla, azeitona e orégano." },
  { name: "Presunto", description: "Molho de tomate, presunto, mussarela, azeitona e orégano." },
  { name: "Dois Queijos", description: "Molho de tomate, mussarela, catupiry e orégano." },
  { name: "Milho", description: "Molho de tomate, mussarela, milho e orégano." },
  { name: "Baiana", description: "Molho de tomate, pimenta, mussarela, cebola, tomate, calabresa, azeitona e orégano." },
  { name: "Margherita", description: "Molho de tomate, manjericão, mussarela, tomate, azeitona e orégano." },
].map((it) => ({ ...it, prices: TIER_TRADICIONAL, tier: "Tradicional", flavorType: "salgada" }));

const especiais = [
  { name: "Napolitana", description: "Molho de tomate, mussarela, tomate, presunto, azeitona, parmesão e orégano." },
  { name: "Frango Catupiry", description: "Molho de tomate, frango, cebola, catupiry, mussarela e orégano." },
  { name: "Frango Cheddar", description: "Molho de tomate, frango, cebola, cheddar, mussarela e orégano." },
  { name: "Calabresa Catupiry", description: "Molho de tomate, mussarela, cebola, calabresa, catupiry e orégano." },
  { name: "Calabresa Cheddar", description: "Molho de tomate, mussarela, cebola, calabresa, cheddar e orégano." },
  { name: "Quatro Queijos", description: "Molho de tomate, mussarela, cheddar, catupiry, parmesão e orégano." },
  { name: "Quatro Maria's", description: "1/4 presunto, 1/4 frango c/ catupiry, 1/4 calabresa, 1/4 milho bacon e orégano." },
  { name: "Brócolis Bacon", description: "Molho de tomate, mussarela, brócolis, bacon, azeitona e orégano." },
  { name: "Portuguesa", description: "Molho de tomate, mussarela, cebola, presunto, pimentão, ovo, azeitona e orégano." },
  { name: "Atum Acebolada", description: "Molho de tomate, atum, cebola, mussarela, azeitona e orégano." },
  { name: "Calabresa com Alho", description: "Molho de tomate, mussarela, calabresa, alho e orégano." },
  { name: "Frango Mussarela com Alho", description: "Molho de tomate, frango, mussarela, alho e orégano." },
  { name: "Brócolis com Alho", description: "Molho de tomate, mussarela, brócolis, alho, azeitona e orégano." },
  { name: "Pepperoni", description: "Molho de tomate, mussarela, pepperoni e orégano." },
  { name: "Frango Mussarela com Milho", description: "Molho de tomate, frango, mussarela, milho e orégano." },
  { name: "Bacon", description: "Molho de tomate, mussarela, bacon e orégano." },
].map((it) => ({ ...it, prices: TIER_ESPECIAL, tier: "Especial", flavorType: "salgada" }));

const premium = [
  { name: "Calabresa Especial", description: "Molho, mussarela, cebola, calabresa, catupiry, bacon e orégano." },
  { name: "Frango Bacon", description: "Molho, frango, mussarela, bacon e orégano." },
  { name: "Frango Bacon Requeijão", description: "Molho, frango, mussarela, bacon, requeijão e orégano." },
  { name: "Tomate Seco Catupiry", description: "Molho, mussarela, catupiry, tomate seco e orégano." },
  { name: "Bacon Catupiry", description: "Molho, mussarela, catupiry, bacon e orégano." },
  { name: "Bacon Cheddar", description: "Molho, mussarela, cheddar, bacon e orégano." },
  { name: "Especial da Casa", description: "Molho, frango, mussarela, tomate, calabresa, catupiry, azeitona e orégano." },
  { name: "Pepperoni Catupiry", description: "Molho, mussarela, pepperoni, catupiry e orégano." },
  { name: "Calabresa, Brócolis Bacon", description: "Molho, mussarela, cebola, calabresa, brócolis, bacon, azeitona e orégano." },
  { name: "Calabresa com Barbecue", description: "Molho, mussarela, cebola, calabresa, barbecue e orégano." },
  { name: "Frango com Barbecue", description: "Molho, frango, mussarela, barbecue e orégano." },
  { name: "Milho Catupiry e Bacon", description: "Molho, mussarela, milho, catupiry, bacon e orégano." },
  { name: "Lombo com Queijo Mussarela", description: "Molho, mussarela, lombo defumado e orégano." },
  { name: "Margherita Cremosa", description: "Molho, mussarela, manjericão, catupiry, azeitona e orégano." },
].map((it) => ({ ...it, prices: TIER_PREMIUM, tier: "Premium", flavorType: "salgada" }));

const superPremium = [
  { name: "Lombo Bacon", description: "Molho, mussarela, lombo, bacon e orégano." },
  { name: "Pepperoni Catupiry Bacon", description: "Molho, mussarela, pepperoni, catupiry, bacon e orégano." },
  { name: "Frango Cheddar Bacon", description: "Molho, frango, mussarela, cheddar, bacon e orégano." },
  { name: "Costela com Catupiry", description: "Molho, costela, cebola, mussarela, catupiry e orégano." },
  { name: "Du Cheff", description: "Molho, frango, mussarela, calabresa, catupiry, bacon e orégano." },
  { name: "Carne Seca com Cream Cheese", description: "Molho, mussarela, cebola, carne seca, cream cheese e orégano." },
  { name: "Lombo Bacon Catupiry", description: "Molho, mussarela, lombo, catupiry, bacon e orégano." },
  { name: "Cheddar Supreme", description: "1/4 presunto, 1/4 frango catupiry, 2/4 calabresa, listras de cheddar e borda recheada de cheddar." },
].map((it) => ({ ...it, prices: TIER_SUPER, tier: "Super Premium", flavorType: "salgada" }));

const docesTradicionais = [
  { name: "Chocolate", description: "Massa artesanal, mussarela, chocolate." },
  { name: "Romeu e Julietta", description: "Massa artesanal, mussarela e doce de goiabada." },
  { name: "Doce de Leite", description: "Massa artesanal, mussarela e doce de leite." },
  { name: "Brigadeiro", description: "Massa artesanal, mussarela, chocolate e granulado." },
  { name: "Beijinho", description: "Massa artesanal, mussarela, leite condensado e coco ralado." },
  { name: "Banana com Canela", description: "Massa artesanal, mussarela, banana, leite condensado e canela." },
  { name: "Chocolate Duo", description: "Massa artesanal, mussarela, chocolate e chocolate branco." },
].map((it) => ({ ...it, prices: TIER_ESPECIAL, tier: "Doce Tradicional", flavorType: "doce" }));

const docesPremium = [
  { name: "Banana com Avelã", description: "Massa artesanal, mussarela, banana, chocolate avelã." },
  { name: "Morango com Avelã", description: "Massa artesanal, mussarela, chocolate avelã e morango." },
  { name: "Chocolate com Oreo", description: "Massa artesanal, mussarela, chocolate branco e oreo." },
  { name: "Sonho de Valsa", description: "Massa artesanal, mussarela, chocolate e sonho de valsa." },
  { name: "Ouro Branco", description: "Massa artesanal, mussarela, chocolate e ouro branco." },
  { name: "Charge", description: "Massa artesanal, mussarela, chocolate, amendoim e doce de leite." },
  { name: "Pistache", description: "Massa artesanal, mussarela, creme de pistache e castanhas de caju." },
  { name: "Pistache Duo", description: "Massa artesanal, mussarela, creme de pistache e chocolate." },
  { name: "Prestígio", description: "Massa artesanal, mussarela, chocolate e coco ralado." },
].map((it) => ({ ...it, prices: TIER_PREMIUM, tier: "Doce Premium", flavorType: "doce" }));

const bebidas = [
  { name: "Guaraná Antarctica 2L", description: "Refrigerante 2 litros gelado.", price: 15.0 },
  { name: "Coca-Cola 2L", description: "Refrigerante 2 litros gelado.", price: 15.0 },
  { name: "Fanta 2L", description: "Refrigerante 2 litros gelado.", price: 15.0 },
  { name: "Tubaína 2L", description: "Refrigerante 2 litros gelado.", price: 7.0 },
  { name: "Refriko 2L", description: "Refrigerante 2 litros gelado.", price: 9.0 },
  { name: "Coca-Cola 600ml", description: "Refrigerante 600ml gelado.", price: 8.0 },
  { name: "Coca-Cola Lata", description: "Lata 350ml gelada.", price: 5.0 },
  { name: "Água (com/sem gás)", description: "Garrafa 500ml.", price: 4.0 },
].map((it) => ({ ...it, tier: "Bebida" }));

export const CATEGORIES = [
  { id: "tradicionais", label: "Tradicionais", type: "pizza", items: withImages(tradicionais, SALGADAS_IMGS) },
  { id: "especiais", label: "Especiais", type: "pizza", items: withImages(especiais, SALGADAS_IMGS) },
  { id: "premium", label: "Premium", type: "pizza", items: withImages(premium, SALGADAS_IMGS) },
  { id: "super-premium", label: "Super Premium", type: "pizza", items: withImages(superPremium, SALGADAS_IMGS) },
  { id: "doces-tradicionais", label: "Doces", type: "pizza", items: withImages(docesTradicionais, DOCES_IMGS) },
  { id: "doces-premium", label: "Doces Premium", type: "pizza", items: withImages(docesPremium, DOCES_IMGS) },
  { id: "bebidas", label: "Bebidas", type: "beverage", items: withImages(bebidas, BEBIDAS_IMGS) },
];

// All pizzas flat (for meio-a-meio picker)
export const ALL_PIZZAS = CATEGORIES.filter((c) => c.type === "pizza").flatMap((c) =>
  c.items.map((it) => ({ ...it, categoryId: c.id, categoryLabel: c.label }))
);

// BORDAS RECHEADAS — priced by size (6/8/12 fatias). Broto não tem borda.
export const BORDAS = [
  { id: "cat-ched", label: "Catupiry / Cheddar", kind: "tradicional", prices: { "6f": 8, "8f": 12, "12f": 14 } },
  { id: "mus-cream", label: "Mussarela / Cream Cheese", kind: "tradicional", prices: { "6f": 11, "8f": 15, "12f": 18 } },
  { id: "alho-4q", label: "Pão de Alho / 4 Queijos", kind: "tradicional", prices: { "6f": 14, "8f": 17, "12f": 20 } },
  { id: "choc-avela", label: "Chocolate Avelã / Chocolate Branco", kind: "doce", prices: { "6f": 11, "8f": 15, "12f": 18 } },
  { id: "romeu-julietta", label: "Romeu e Julietta", kind: "doce", prices: { "6f": 12, "8f": 16, "12f": 19 } },
  { id: "sonho-especial", label: "Sonho de Valsa / Ouro Branco / Pistache / Oreo", kind: "doce", prices: { "6f": 16, "8f": 18, "12f": 20 } },
];

// Delivery fees per bairro (Londrina)
export const BAIRROS = [
  { id: "centro-gleba", label: "Centro / Gleba Palhano", fee: 5.0 },
  { id: "ouro-norte", label: "Ouro Verde / Zona Norte", fee: 8.0 },
  { id: "outros", label: "Outros Bairros", fee: 10.0 },
];

export const RESTAURANT = {
  name: "Dona Maria Pizzaria",
  tagline: "Pizzas artesanais assadas com carinho em Londrina",
  city: "Londrina — PR",
  whatsapp: "5543998422374",
  pix: {
    key: "donamaria@pizzaria.com",
    keyType: "E-mail",
    holder: "Dona Maria Pizzaria LTDA",
  },
  hours: [
    { day: "Segunda", time: "18h15 às 23h" },
    { day: "Terça", time: "Fechado", closed: true },
    { day: "Quarta", time: "18h15 às 23h" },
    { day: "Quinta", time: "18h15 às 23h" },
    { day: "Sexta", time: "18h15 às 23h59" },
    { day: "Sábado", time: "18h15 às 23h59" },
    { day: "Domingo", time: "18h15 às 23h30" },
  ],
};
